import axios from './axios'

const API_ENDPOINT = '/api';

const API_ROUTES = {
    login: `${API_ENDPOINT}/login/`,
    listMethods: `${API_ENDPOINT}/methods/`,
    listTasks: `${API_ENDPOINT}/tasks/`,
    methodInfo: `${API_ENDPOINT}/method/`,
    addTask: `${API_ENDPOINT}/task/`,
    downloadFile: `${API_ENDPOINT}`,
    listDataSets: `${API_ENDPOINT}/datasets/`,
    licenseAgreement: `${API_ENDPOINT}/profile/`,
    listFiles: `${API_ENDPOINT}/datafiles/`,
    mailer: `${API_ENDPOINT}/mailer/`,
    registration: `${API_ENDPOINT}/registration/`
};

export class AuthAPI {
    static async logIn({username, password}) {
        try {
            const result = await axios.post(API_ROUTES.login, {username, password});
            return result.data
        } catch(error) {
            throw error.response.data
        }
    }

    static logOut() {
        delete axios.defaults.headers.common['Authorization']
    }

    static async requestAccount(registrationForm) {
      // for (const pair of registrationForm.entries()) {
      //   window.console.log(pair[0] + ", " + pair[1]);
      // }
      try {
        const result = await axios.post(API_ROUTES.registration, registrationForm, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        });
        return result.data
      } catch(error) {
        throw error.response.data
      }
    }

    static async submitLicenseAgreement() {
        try {
          const result = await axios.put(API_ROUTES.licenseAgreement);
          return result.data
        } catch (e) {
          throw e.response.data
        }
    }

    static setupAxiosHeadersWithToken(token) {
        axios.defaults.headers.common['Authorization'] = `Token ${token}`
    }
}

export class MethodsAPI {
    static async listMethods() {
        try {
            const result = await axios.get(API_ROUTES.listMethods);
            return result.data
        } catch(error) {
            throw error.response.data
        }
    }
    static async methodInfo(methodId) {
        try {
            const route = `${API_ROUTES.methodInfo}${methodId}/`;
            const result = await axios.get(route);
            return result.data
        } catch(error) {
            throw error.response.data
        }
    }
}

export class TasksAPI {
    static async listTasks() {
        try {
            const result = await axios.get(API_ROUTES.listTasks);
            return result.data
        } catch(error) {
            throw error.response.data
        }
    }
    static async addTask(taskForm) {
        try {
            const formData = new FormData();

            for (const key in taskForm) {
              formData.append(key, taskForm[key]);
            }

            const result = await axios.post(API_ROUTES.addTask, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });

            return result.data
        } catch(error) {
            throw error.response.data
        }
    }

    static async taskInfo(task) {
        try {
            const result = await axios.get(API_ENDPOINT+task.infoLink);
            return result.data
        } catch(error) {
            throw error.response.data
        }
    }

    static downloadResultRoute(task) {
        return API_ROUTES.downloadFile + task.downloadLink
    }

    static async abortTask(task) {
        try {
            await axios.post(API_ENDPOINT+task.abortLink)
        } catch (e) {
            throw e
        }
    }
}

export class DatasetsAPI {
    static async listDataSets() {
        try {
            const result = await axios.get(API_ROUTES.listDataSets);
            return result.data
        } catch(error) {
            throw error.response.data
        }
    }
}

export class FeedBackAPI {
  static async sendFeedBack(feedBackForm) {
    try {
      const result = await axios.post(API_ROUTES.mailer, feedBackForm, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      return result.data
    } catch(error) {
      throw error.response.data
    }
  }
}

export class FilesAPI {
  static async getFiles() {
    try {
      const result = await axios.get(API_ROUTES.listFiles);
      return result.data
    } catch (e) {
      throw (e)
    }
  }
}
